import { useRef } from "react";
import PhoneInput from "react-phone-number-input";

import styles from "./custom-input-phone.module.scss";

const CustomInputPhone = ({
	id,
	name,
	label,
	value,
	onChange,
	placeholder = "Número de teléfono",
	required = false,
	disabled = false,
	error = "",
	helper = "",
	size = "md",
	col = 12,
	defaultCountry = "CL",
	countries = ["CL", "UY"],
	className,
	style,
}) => {
	const stableIdRef = useRef(id || `${name || "phone"}-${Math.random().toString(36).slice(2)}`);
	const inputId = stableIdRef.current;
	const colClass = col === 3 ? styles.col3 : col === 6 ? styles.col6 : styles.col12;
	const describedBy = error ? `${inputId}-error` : helper ? `${inputId}-helper` : undefined;

	return (
		<div className={`${styles.field} ${colClass} ${className || ""}`} style={style}>
			{label ? (
				<label htmlFor={inputId} className={styles.label}>
					{label} {required ? <span className={styles.req}>*</span> : null}
				</label>
			) : null}

			<PhoneInput
				id={inputId}
				name={name}
				value={value || ""}
				onChange={onChange}
				defaultCountry={defaultCountry}
				countries={countries}
				placeholder={placeholder}
				disabled={disabled}
				className={`${styles.phoneInput} ${styles[size]} ${error ? styles.phoneInputError : ""}`}
				international
				aria-invalid={!!error || undefined}
				aria-describedby={describedBy}
			/>

			{error ? (
				<div id={`${inputId}-error`} className={styles.error}>
					{error}
				</div>
			) : helper ? (
				<div id={`${inputId}-helper`} className={styles.helper}>
					{helper}
				</div>
			) : null}
		</div>
	);
};

export default CustomInputPhone;
